import { render, staticRenderFns } from "./SubscribeTshirt.vue?vue&type=template&id=02d22260&scoped=true&"
import script from "./SubscribeTshirt.vue?vue&type=script&lang=js&"
export * from "./SubscribeTshirt.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeTshirt.vue?vue&type=style&index=0&id=02d22260&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d22260",
  null
  
)

export default component.exports